import angular from 'angular';
import moment from 'moment';
import guid from '@/shared/utils/guid';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import DocumentService from '@/shared/services/DocumentService';

angular
  .module('cloudX')
  .controller('FiscalInsuranceDialog', [
    '$http',
    'appUrls',
    'flySvc',
    'checkSecurity',
    '$element',
    'close',
    'relationId',
    'data',
    'documents',
    fiscalInsuranceDialog,
  ]);

function fiscalInsuranceDialog(
  $http,
  appUrls,
  flySvc,
  checkSecurity,
  $element,
  close,
  relationId,
  data,
  documents,
) {
  var vm = this;
  vm.saving = false;
  vm.readOnly = !checkSecurity('Relation:u');
  vm.showValidation = false;
  vm.datepickerOptions = {
    startingDay: 1,
    initDate: moment
      .utc()
      .startOf('day')
      .toDate(),
  };

  vm.relationId = relationId;
  vm.documentsAccessor = {};
  vm.documentLinkType = 8;
  vm.documents = [...(documents || [])];
  vm.documentsChanged = false;
  vm.onDocumentsChanged = function() {
    vm.documentsChanged = true;
  };

  vm.realEstates = [];
  vm.selectedRealEstate = {};

  var getRealEstates = () => {
    vm.loading = true;
    $http.get(`${appUrls.api}/api/Fiscal/realEstates/${relationId}`).then(
      function(result) {
        vm.realEstates = result.data;
        setupViewModels();
      },
      function(error) {
        flySvc.error(error);
        setupViewModels();
      },
    );
  };
  getRealEstates();
  var setupViewModels = () => {
    vm.insurance = angular.extend(
      {
        relationId: relationId,
        creditInstitution: null,
        reference: null,
        amount: null,
        date: null,
        purpose: null,
        repaymentAmount: null,
        repaymentMonths: null,
        professionalUsePercentage: null,
        remark: null,
      },
      data,
    );
    vm.endUser = {
      relation: vm.insurance.endUser,
      text: vm.insurance.endUserName,
    };

    vm.selectedRealEstate = vm.insurance.realEstateId
      ? vm.realEstates.find(x => x.id === vm.insurance.realEstateId)
      : null;
    vm.loading = false;
  };

  vm.endUserChanged = function() {
    const { relation = null, text = null } = vm.endUser || {};

    vm.insurance.endUser = relation;
    vm.insurance.endUserName = text;
  };

  vm.save = function() {
    if (vm.form.$invalid) return '';
    if (vm.saving) return '';

    var model = {
      ...vm.insurance,
      realEstateId: vm.selectedRealEstate?.id,
    };

    vm.saving = true;
    $http.post(`${appUrls.api}/api/Fiscal/Insurance`, model).then(
      function({ data }) {
        if (typeof data.date === 'string') data.date = moment.utc(data.date.substr(0, 10)).toDate();

        if (data.id) {
          vm.insurance.id = data.id;
          if (vm.documentsAccessor && vm.documentsAccessor.uploadNewDocuments) {
            return vm.documentsAccessor.uploadNewDocuments(data.id).then(changed => {
              vm.saving = false;
              flySvc.success();

              close([data, changed || vm.documentsChanged ? vm.documents : null], 500);
              $element.modal('hide');
            });
          }
        }

        vm.saving = false;
        flySvc.success();
        close([data, vm.documentsChanged ? vm.documents : null], 500);
        $element.modal('hide');
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error);
        return '';
      },
    );
  };
  vm.cancel = function() {
    close([null, vm.documentsChanged ? vm.documents : null], 500);
  };
}
